/** 將參數轉成 key */
import { compose, join, values } from 'ramda';

export const toKey = compose(join('_'), values);
